import { IPhoneNumber } from 'shared/interfaces/IAccount';

export const INITIAL_PHONE_NUMBERS: IPhoneNumber[] = [
  {
    type: 'primary',
    country_code: 'us',
    number: '',
  },
  {
    type: 'secondary',
    country_code: 'us',
    number: '',
  },
  {
    type: 'other',
    country_code: 'us',
    number: '',
  },
  {
    type: 'other',
    country_code: 'us',
    number: '',
  },
];
